import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ConfigInterface } from './config.interface';

export const ConfigActions = createActionGroup({
  source: 'Config',
  events: {
    'Get config': emptyProps(),
    'Get config success': props<ConfigInterface>(),
    'Set dark mode status': props<{ status: boolean }>(),
    'Set webapp mode': emptyProps(),
  },
});

export type GetConfigActionUnion = ReturnType<typeof ConfigActions[keyof typeof ConfigActions]>;

export type GetConfigAction = ReturnType<typeof ConfigActions.getConfig>;
export type GetConfigSuccessAction = ReturnType<typeof ConfigActions.getConfigSuccess>;
export type SetDarkModeStatusAction = ReturnType<typeof ConfigActions.setDarkModeStatus>;
export type SetWebappModeAction = ReturnType<typeof ConfigActions.setWebappMode>;
